import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type AboutState = { title?: string; content?: string; };

const initialState: AboutState = {
};
export const aboutSlice = createSlice({
    name: "about",
    initialState,
    reducers: {
        aboutUpdate: (
            state,
            action: PayloadAction<AboutState>
        ) => {
            state.title = action.payload.title;
            state.content = action.payload.content;
        }
    },
});

export const { aboutUpdate } = aboutSlice.actions;
export default aboutSlice.reducer;
